<template>
  <div class="flex flex-col items-center sm:items-start">
    <!-- Ícone Vue -->
    <img
      src="@/assets/images/logo.png"
      alt="Vue Logo"
      class="w-80 h-auto mb-2"
    />

    <!-- Texto principal -->
    <h1 class="text-4xl text-white font-bold text-center sm:text-left">
      Bem-vindo ao CISA
    </h1>
    <p class="text-lg mt-4 text-white text-center sm:text-left">
      (Compliance Information Assessment Tool) uma plataforma desenvolvida para
      avaliar o nível de aderência das organizações aos requisitos de
      segurança...
    </p>
  </div>
</template>
